import { API_BASE_URL } from '../config/api';
import { searchShippingAreas } from '../services/shippingAddressApi';

function pickComponent(components, type) {
  const row = (components || []).find((item) => Array.isArray(item.types) && item.types.includes(type));
  return String(row?.long_name || '').trim();
}

function normArea(value) {
  return String(value || '')
    .toLowerCase()
    .replace(/\b(kota|kabupaten|kab\.?|kecamatan|kec\.?|administrasi)\b/g, '')
    .replace(/\s+/g, ' ')
    .trim();
}

export function formatWilayahLabel(provinsi, kota, kecamatan, kodepos) {
  return [provinsi, kota, kecamatan, kodepos]
    .map((part) => String(part || '').trim())
    .filter(Boolean)
    .join(', ');
}

export function parseGeocodeLabel(data) {
  if (data?.plus_code && typeof data.plus_code.compound_code === 'string') {
    return data.plus_code.compound_code;
  }
  if (Array.isArray(data?.results) && data.results.length > 0) {
    return data.results[0].formatted_address || 'Unknown address';
  }
  return 'Location not found';
}

export function geocodeHint(data) {
  const result = Array.isArray(data?.results) && data.results[0] ? data.results[0] : null;
  const components = result?.address_components || [];
  return {
    kodepos: pickComponent(components, 'postal_code'),
    kecamatan:
      pickComponent(components, 'administrative_area_level_3')
      || pickComponent(components, 'sublocality_level_1')
      || pickComponent(components, 'sublocality'),
    kota:
      pickComponent(components, 'administrative_area_level_2')
      || pickComponent(components, 'locality'),
    provinsi: pickComponent(components, 'administrative_area_level_1'),
  };
}

function pickBestArea(rows, hint) {
  if (!Array.isArray(rows) || rows.length === 0) return null;
  if (hint.kodepos) {
    const byZip = rows.find((row) => String(row.kodepos) === String(hint.kodepos));
    if (byZip) return byZip;
  }
  const kec = normArea(hint.kecamatan);
  if (kec) {
    const byKec = rows.find((row) => {
      const name = normArea(row.nama_kecamatan);
      return name === kec || name.includes(kec) || kec.includes(name);
    });
    if (byKec) return byKec;
  }
  const kota = normArea(hint.kota);
  if (kota) {
    const byKota = rows.find((row) => normArea(row.nama_kota).includes(kota) || kota.includes(normArea(row.nama_kota)));
    if (byKota) return byKota;
  }
  return rows[0];
}

export async function fetchGeomap(lat, lng) {
  const url = new URL(`${API_BASE_URL}/api/geomap`);
  url.searchParams.set('latlng', `${lat},${lng}`);
  const res = await fetch(url);
  return res.json();
}

export async function resolveBiteshipArea(data) {
  const hint = geocodeHint(data);
  const queries = [hint.kodepos, hint.kecamatan, hint.kota]
    .map((value) => String(value || '').trim())
    .filter((value) => value.length >= 2);

  for (const query of queries) {
    try {
      const rows = await searchShippingAreas(query, 15);
      const match = pickBestArea(rows, hint);
      if (match) return match;
    } catch {
      // try next query
    }
  }
  return null;
}
